<template>
  <div>
    <button
      v-if="isLogined"
      :class="{
        'followed': followed,
        'non-login': !$auth.loggedIn && !logined,
        'icon-view btn-default' : iconView,
        'p-default': isProfilePage
      }"
      @click.prevent="followAction()"
      :disabled="waiting !== 0"
      class="btn btn-sm rounded-sm folbtn"
    >
      <!-- icon view only for mobile profile follow page -->

      <div v-if="waiting === 0">
        <span v-if="isProfilePage" class="p-unfollow">{{ cpLang('jd.unfollow') }}</span>
        <i v-if="iconView" v-show="iconView" class="fas fa-times" />
        <span v-else>{{ followText }}</span>
      </div>
      <div v-else>
        <i class="fas fa-circle-notch fa-spin" />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isLogined: {
      default: false,
      type: Boolean
    },
    iconView: {
      default: false,
      type: Boolean
    },
    followStatus: {
      default: false,
      type: Boolean
    },
    logoId: {
      default: 0 || '0',
      type: [Number, String]
    },
    checkFollow: {
      default: false,
      type: Boolean
    },
    isProfilePage: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      followed: false,
      logined: false,
      waiting: 0
    }
  },
  computed: {
    navLogin() {
      return this.$auth.loggedIn
    },
    logoid() {
      return parseInt(this.logoId)
    },
    followText() {
      return this.followed ? this.cpLang('jd.unfollow') : this.cpLang('jd.follow')
    }
  },
  watch: {
    navLogin(nv, ov) {
      if (nv) {
        this.$emit('navlogin')
      }
    },
    followStatus(n) {
      this.followed = n
    },
    isLogined() {
      this.getFollowStatus()
    }
  },
  mounted() {
    this.logined = this.isLogined
    if (this.checkFollow && this.logined) {
      this.getFollowStatus()
    }
  },
  methods: {
    followAction: async function () {
      if (this.iconView) {
        this.unfollowAction()
        return false
      }
      if (this.followed) {
        this.unfollowAction()
        return
      }
      const vm = this
      this.waiting = 1
      const headers = { 'Content-Type': 'application/json' }
      if (this.isLogined) {
        await this.$axios.post('member/myjob/followed/' + this.logoid, { headers: headers })
        this.followed = true
        const wait = setInterval(function() {
          vm.waiting--
          if (vm.waiting === 0) {
            clearInterval(wait)
          }
        }, 1000)
      }
    },
    unfollowAction: async function() {
      const vm = this
      this.waiting = 1
      const headers = { 'Content-Type': 'application/json' }
      if (this.isLogined) {
        await this.$axios.delete('member/myjob/followed/' + this.logoid, { headers: headers })
        this.followed = false
        this.$emit('unfollow', this.logoid)
        const wait = setInterval(function() {
          vm.waiting--
          if (vm.waiting === 0) {
            clearInterval(wait)
          }
        }, 1000)
      }
    },
    getFollowStatus: function() {
      const vm = this
      this.$axios.get('member/myjob/followed/' + this.logoid).then(function (resp) {
        if (resp.data.length === 0) {
          vm.followed = false
        } else {
          vm.followed = true
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .folbtn{
    height:max-content;
    margin:25px 0px 10px 15px;
    font-weight:100;
    color:#fff;
    background:#0081be;
    border: 1px solid #0081be !important;
    transition: all .2s;
    padding: 1px 7px;
    font-size: 12px;
    &:hover{
      color: #fff !important  ;
      background-color:#006594;
    }
    &.followed{
      padding: 1px 7px !important;
      border: 1px solid #0EA5BF !important;
      background-color:#fff  !important;
      color:#0EA5BF !important;
    }
    &.non-login {
      opacity: 0.5;
    }
    &.icon-view{
      margin: 0 !important;
    }
    &.p-default{
      border: unset !important;
      background: #0EA5BF !important;
    }
  }
  .vtoo{
    &.d-none{
      display: none !important;
    }
  }
</style>
